document.addEventListener('DOMContentLoaded', () => {
    const buttonsPrimary = document.querySelectorAll('.button.button--primary');
    const buttonsSecondary = document.querySelectorAll('.button.button--secondary');

    buttonsPrimary.forEach((button) => {
        if(!button.classList.contains('tab__item') && !button.classList.contains('form-button')) {
            let originalBg = '';
            let originalColor = '';
            const fallbackBg = '#C1D82F';
            const fallbackColor = '#333333';

            button.addEventListener('mouseenter', () => {
                const computedStyles = window.getComputedStyle(button);
                originalBg = computedStyles.backgroundColor;
                originalColor = computedStyles.color;

                const isTransparent = originalBg === 'transparent' || originalBg === 'rgba(0, 0, 0, 0)';

                const newBg = isTransparent ? fallbackBg : 'white';
                const newColor = isTransparent ? fallbackColor : originalColor;

                button.style.backgroundColor = newBg;
                button.style.color = newColor;
            });

            button.addEventListener('mouseleave', () => {
                button.style.backgroundColor = originalBg;
                button.style.color = originalColor;
            });
        }
    });

    buttonsSecondary.forEach((button) => {
        if(!button.classList.contains('tab__item') && !button.classList.contains('remove-button-card') && !button.classList.contains('form-button') && !button.classList.contains('button--close')) {
            let originalBg = '';
            let originalColor = '';
            const fallbackBg = '#C1D82F';
            const fallbackColor = '#333333';

            button.addEventListener('mouseenter', () => {
                const computedStyles = window.getComputedStyle(button);
                originalBg = computedStyles.backgroundColor;
                originalColor = computedStyles.color;

                const isTransparent = originalBg === 'transparent' || originalBg === 'rgba(0, 0, 0, 0)';

                const newBg = isTransparent ? fallbackBg : originalColor;
                const newColor = isTransparent ? fallbackColor : originalBg;

                button.style.backgroundColor = newBg;
                button.style.color = newColor;
            });

            button.addEventListener('mouseleave', () => {
                button.style.backgroundColor = originalBg;
                button.style.color = originalColor;
            });
        }
    });
});